export default "__VITE_ASSET__DDnPnTMD__"